import { axios } from '@/request-clients/axios';
import { useQuery } from '@tanstack/react-query';
import { AppErrorBanner } from '@my-ipractice/types';

export const useGetErrorBanner = () => {
  return useQuery<AppErrorBanner>({
    queryFn: async () => {
      const res = await axios.get(`clients/health/error-banner`);
      return res.data;
    },
    queryKey: ['app-health', 'error-banner'],
    meta: {
      errorMessage: 'Error fetching error banner',
    },
  });
};
